import React from 'react';
import gylymKoryLogo from '../../../assets/images/logo.jpg';

function Third() {

    // Партнерлер — компаниялар
    const partners = [
        { id: 3, logo: null, image: `${process.env.PUBLIC_URL || ''}/partners/pravovoy-konsulting.png`, name: 'ПРАВОВОЙ КОНСАЛТИНГ.KZ' },
        { id: 4, logo: null, image: gylymKoryLogo, name: 'Ғылым қоры' },
        { id: 5, logo: null, image: 'https://static.tildacdn.pro/tild6233-3533-4430-a231-326461346234/svgexport-1.svg', name: 'BNK Group', link: 'https://bnkgroup.kz/' },
        { id: 6, logo: null, image: 'https://www.prst.kz/images/head_pic/logo.png?1', name: 'prst.kz', link: 'https://www.prst.kz/' },
    ];


    return (
        <div className="w-full bg-white py-4 px-5 md:px-[60px] lg:px-[120px] xl:px-[240px]">
            <div className="flex flex-col gap-10">
                {/* Карусель партнеров */}
                <div>
                    <div>
                        <div className="relative overflow-hidden">
                            <div className="flex animate-scroll gap-8 will-change-transform" style={{ width: 'max-content' }}>
                                {[...partners, ...partners, ...partners].map((partner, index) => {
                                    const isPravovoy =
                                        typeof partner.image === 'string' && partner.image.includes('/partners/pravovoy-konsulting.png');
                                    const content = (
                                        <>
                                            {partner.logo ? (
                                                partner.logo
                                            ) : (
                                                <img
                                                    src={partner.image || '/logo-gylym-kory.png'}
                                                    alt={partner.name || 'Ғылым қоры'}
                                                    className={[
                                                        'w-full h-full object-contain p-2 md:p-3',
                                                        isPravovoy ? 'bg-white rounded-xl' : '',
                                                    ]
                                                        .filter(Boolean)
                                                        .join(' ')}
                                                    onError={(e) => {
                                                        e.target.style.display = 'none';
                                                        e.target.parentElement.innerHTML =
                                                            '<span class="text-sm text-gray-500">Ғылым қоры</span>';
                                                    }}
                                                />
                                            )}
                                        </>
                                    );
                                    const className = [
                                        'flex-shrink-0 w-32 h-16 sm:w-36 sm:h-20 md:w-40 md:h-24 flex items-center justify-center transition-colors',
                                        isPravovoy ? 'bg-white rounded-xl shadow-sm' : '',
                                    ]
                                        .filter(Boolean)
                                        .join(' ');
                                    return partner.link ? (
                                        <a
                                            key={`${partner.id}-${index}`}
                                            href={partner.link}
                                            target="_blank"
                                            rel="noreferrer"
                                            className={`${className} no-underline text-inherit hover:opacity-90`}
                                            title={partner.name}
                                        >
                                            {content}
                                        </a>
                                    ) : (
                                        <div key={`${partner.id}-${index}`} className={className}>
                                            {content}
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Third;
